<!--
 * @Author: hongye yanghongye@jtexpress.com
 * @Date: 2025-06-04 10:43:38
 * @Description: 敏感字段脱敏与授权反查展示
 * @FilePath: /DecryptIdCardV2.vue
-->
<template>
  <span class="decrypt">
    <template v-if="maskedValue">
      <span class="flex_1">{{ displayValue || '--' }}</span>
      <LoadingOutlined v-show="state.loading" class="ml-4" style="font-size: 16px; color: var(--primary-color)" />
      <EyeInvisibleTwoTone
        v-show="!state.loading && state.revealed"
        @click="getCardId"
        class="real-user-show"
        :two-tone-color="primaryColor"
      />
      <EyeTwoTone
        v-show="!state.loading && !state.revealed"
        @click="getCardId"
        class="real-user-show"
        :two-tone-color="primaryColor"
      />
    </template>
    <template v-else>
      --
    </template>
  </span>
</template>
<script setup lang="ts" name="DecryptIdCardV2">
  import { computed, reactive, watch } from 'vue'
  import { useRoute } from 'vue-router'
  import { EyeTwoTone, EyeInvisibleTwoTone, LoadingOutlined } from '@ant-design/icons-vue'
  import getPhoneService from '@/service/api/getPhone'
  import { isSuccess, getPrimaryColor } from '@/utils'
  const primaryColor = getPrimaryColor()
  const route = useRoute()

  interface Props {
    id: string | number
    phone: string
    /**
     * 后端 SensitiveEnum 字段 code。VN SITE 使用 001/002/003/007/008/009/022-025/
     * 032-037/046；字段和页面必须同时命中后端 source + path + code 白名单。
     */
    scenes: string
    menuName: string
    optType?: 'DETAIL' | 'LIST' | 'SENDER' | 'RECEIVER'
  }
  const props = defineProps<Props>()
  const maskedValue = computed(() => props.phone || '')
  /** 查看手机号 */
  const state = reactive({
    /** 加载中 */
    loading: false,
    /** 是否显示明文 */
    revealed: false,
    /** 结果 */
    result: ''
  })

  const displayValue = computed(() => (state.revealed ? state.result : maskedValue.value))
  let requestVersion = 0

  const reset = () => {
    requestVersion += 1
    state.loading = false
    state.revealed = false
    state.result = ''
  }

  watch([() => props.id, () => props.phone, () => props.scenes, () => route.path], reset)

  const getCardId = async () => {
    if (state.loading) return

    if (state.revealed) {
      reset()
      return
    }

    const currentRequestVersion = ++requestVersion
    state.loading = true
    try {
      const res = await getPhoneService.getPhone({
        key: props.id,
        code: props.scenes,
        path: route.path,
        menuName: props.menuName,
        optType: props.optType || 'LIST'
      })

      if (currentRequestVersion !== requestVersion) return

      if (isSuccess(res) && res.data !== null && res.data !== undefined && String(res.data).length > 0) {
        state.result = String(res.data)
        state.revealed = true
      } else {
        reset()
      }
    } catch {
      if (currentRequestVersion === requestVersion) reset()
    } finally {
      if (currentRequestVersion === requestVersion) state.loading = false
    }
  }
</script>
<style lang="less" scoped>
  .decrypt {
    display: flex;
    justify-content: center;
    align-items: center;
    &.start {
      justify-content: flex-start;
    }
    .flex_1 {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .real-user-show {
      cursor: pointer;
      margin-left: 4px;
    }
  }
</style>
